<div class="card mb-6" *ngIf="establishment?._id">
  <!-- Bannière de retour au bâtiment après modification -->
  <base-banner-message
    *ngIf="returnContext.show && addressModified"
    [text]="
      'Adresse principal modifiée. Retournez à la checklist du bâtiment <strong>' +
      returnContext.buildingLabel +
      '</strong>.'
    "
    [alertType]="'default'"
    [showButton]="true"
    [textButton]="'RETOUR À LA CHECKLIST DU BÂTIMENT'"
    [callButton]="navigateToBuilding.bind(this)"
    [dismissible]="true"
    (onDismiss)="dismissBanner()"
  ></base-banner-message>
  <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title m-0">Localisations</h2>
  </div>

  <div class="px-gutter py-4">
    <base-data-table-header
      label="Adresses"
      [canCreate]="false"
      (onSearchChange)="onSearchChange($event)"
      (onClearTextFilter)="clearTextFilter()"
    ></base-data-table-header>
    <base-data-table
      *ngIf="dataSourceAddresses?.data?.length; else noAddresses"
      [count]="countAddresses"
      [pageSize]="pageSizeAddress"
      [sortField]="sortFieldAddress"
      [sortOrder]="sortOrderAddress"
      [dataSource]="dataSourceAddresses"
      [feisColumns]="feisColumnsAddress"
      [displayedColumns]="displayedColumnsAddress"
      (onPageEvent)="pageEvent($event)"
      (onSortEvent)="sortEvent($event)"
      (onSelectedRow)="favoriteAddressEstablishment($event)"
    ></base-data-table>
    <ng-template #noAddresses>
      <div class="px-gutter py-8 text-center text-gray-500">
        <mat-icon class="text-4xl mb-2">home</mat-icon>
        <p>Aucune adresse trouvée pour cet établissement</p>
        <p class="text-sm">Les adresses sont héritées des bâtiments liés à cet établissement</p>
      </div>
    </ng-template>
  </div>
</div>
